import axios from "axios";
const ENDPOINT_KEY = "sms-notification";
const ENDPOINT_URI = "/sms-notification";

export default function useNotificationService() {
  return {
    queryKey: ENDPOINT_KEY,
    getSmsGateWayAccountStatus: async () => {
      const response = await axios.get(`${ENDPOINT_URI}/account`);
      return response.data.payload;
    },
    getSmsHistory: async (type = "", pending = false, page = 1, limit = 10) => {
      const params = new URLSearchParams({
        page,
        limit,
        pending,
      });
      if (type) {
        params.append("type", type);
      }
      const response = await axios.get(`${ENDPOINT_URI}`, {
        params,
      });
      return response.data.payload;
    },
    getSmsById: async (id) => {
      const response = await axios.get(`${ENDPOINT_URI}/${id}`);
      return response.data.payload;
    },
    createSmsNotification: async ({ payload }) => {
      const response = await axios.post(`${ENDPOINT_URI}`, payload);
      return response.data.payload;
    },
    updateScheduleMessage: async (id, { payload }) => {
      const response = await axios.put(`${ENDPOINT_URI}/${id}`, payload);
      return response.data.payload;
    },
    deleteScheduleMessage: async (id) => {
      const response = await axios.delete(`${ENDPOINT_URI}/${id}`);
      return response.data.payload;
    },
  };
}
